import PropTypes from 'prop-types';

import { Info } from 'lucide-react';
import { DefaultTooltip, Button } from 'twyne-new.ui';

const propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.bool,
};

export default function InfoTip({ children, icon, disabled, color, ...props }) {
  return <DefaultTooltip content={children || ''} {...props} contentProps={{ className: 'max-w-50' }}>
    <Button variant='ghost' color={color} className='m-0 p-0 flex items-center hover:bg-transparent!' disabled={disabled}>
      {icon ? <Info size={14} /> : null}
    </Button>
  </DefaultTooltip >
}

InfoTip.propTypes = propTypes
InfoTip.defaultProps = {
  disabled: false,
  color: '',
  icon: true,
}
